import { Component, ElementRef } from '@angular/core';
import { FieldConfig } from '@smartflip/data-models';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'lib-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  imports: [CommonModule, IonicModule, ReactiveFormsModule],
})
export class DatePickerComponent {
  public field!: FieldConfig;
  public group!: UntypedFormGroup;
  public fieldValue: any;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.fieldValue = new Date(
      this.group.get(this.field.name || 'date')?.value,
    ).toISOString();
    console.log('DatePickerComponent - ngOnInit', this.fieldValue);
  }

  scrollIntoView() {
    this.el.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}
